module.exports = __webpack_public_path__ + "static/media/logo-ps4.4a3d3692.svg";